import { defaultConfig } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig/default';

// renderer进程：获取全局设置 window.envs 主要用在私有化里
function getEnvs() {
  try {
    return window && window.envs ? window.envs : defaultConfig;
  } catch (e) {
    return defaultConfig;
  }
}
export const windowEnvs = getEnvs();
